import React, {lazy, useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Footer from './components/Footer';
import NavMenu from './components/NavMenu';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import {HashLoader} from 'react-spinners';
import {css} from 'styled-components';
import {withLazyLoading} from "./utils/withLazyLoading";
import styled from 'styled-components';
import MainBg from '../src/assets/images/AppBg.png'

//React.lazy
const About = lazy(() => import('./pages/About').then(({default: About}) => ({default: About})))
const Projects = lazy(() => import('./pages/Projects').then(({default: Projects}) => ({default: Projects})))
const Contact = lazy(() => import('./pages/Contact').then(({default: Contact}) => ({default: Contact})))


const override = css`
  display: block;
  margin: 0 auto;
  align-items: center;
  position: absolute !important;
  left: 49%;
  top: 52%;
  z-index: 1;
  @media only screen and (max-width: 1024px) {
    left: 47%
  }
  @media only screen and (max-width: 768px) {
    left: 46%
  }
  @media only screen and (max-width: 425px) {
    left: 44%
  }
  @media only screen and (max-width: 375px) {
    left: 42%
  }
  @media only screen and (max-width: 320px) {
    left: 41%
  }

`;


export default function App() {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 3000);
    }, []);


    return (
        <>
            {
                loading ?
                    <>

                        <Wrapper>
                            <img src={MainBg} alt="bg_title"/>
                            <HashLoader
                                css={override}
                                size={70}
                                color={'#8a8585'}
                                loading={loading}
                                speedMultiplier={1.5}/>
                        </Wrapper>
                    </>
                    :
                    <Router>
                        <NavMenu/>
                        <ScrollToTop/>
                        <Switch>
                            <Route path='/about'
                                   render={withLazyLoading(About)}/>}/>

                            <Route path='/contact'
                                   render={withLazyLoading(Contact)}/>}/>
                            />

                            <Route path='/projects'
                                   render={withLazyLoading(Projects)}/>}/>
                            />
                            <Route path='/'>
                                <Home/>
                            </Route>
                        </Switch>
                        <Footer/>
                    </Router>
            }
        </>
    );
}
const Wrapper = styled.div`
  height: 100vh;
  overflow: hidden;

  img {
    background: center, no-repeat;
    object-fit: cover;
    position: relative;
    z-index: 0;

  }`
